export const GET_LOGGED_IN_USER = 'GET_LOGGED_IN_USER';